import { Button, styled } from '@mui/material';
import { createLink } from '@tanstack/react-router';

const StyledButton = styled(Button)({
  minWidth: 'unset',
  textTransform: 'none'
});

export const LinkButton = createLink(StyledButton);
